module.exports = __webpack_public_path__ + "public/images/math.6f64481170357a8c6379db0e677b93e3.png";